window.theme = window.theme || {};

theme.Collection = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Collection(container) {
    this.filterSelect = container.querySelector(selectors.filterSelection);
    this.sortSelect = container.querySelector(selectors.sortSelection);

    this.selects = document.querySelectorAll(selectors.selectInput);

    if (this.sortSelect) {
      this.defaultSort = this._getDefaultSortValue();
    }

    if (this.selects.length) {
      this.selects.forEach(function(select) {
        select.classList.remove('hidden');
      });
    }

    this.initBreakpoints = this._initBreakpoints.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);

    if (this.filterSelect) {
      this.filterSelect.addEventListener(
        'change',
        this._onFilterChange.bind(this)
      );
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
    }

    theme.Helpers.promiseStylesheet().then(
      function() {
        this._initBreakpoints();
      }.bind(this)
    );
    this._initParams();


    var formsArr = container.querySelectorAll('[action="/cart/add"]');
    if(formsArr.length) {
      formsArr.forEach(function(form,index) {
        theme.AddItemToCart(form);

      });
    }
    theme.ProductItemSwatches();

    var sidebar_menu_items = container.querySelectorAll('.panel-heading.collapse');
    if(sidebar_menu_items.length) {
      sidebar_menu_items.forEach(function (item,index) {
        item.addEventListener('click',function (e) {
          e.preventDefault();

          
          var self = this;
          var panelId = item.getAttribute('data-collapse-panel');
          var itemPanel = document.querySelector('#'+panelId);

             for (let sibling of self.parentNode.children) {
        if (sibling !== self)  {
          if(sibling.classList.contains('active') && sibling.classList.contains('panel-heading') ) {
          sibling.dispatchEvent(new Event('click', { bubbles: true }));

          }
        }
          }
          
 

          if (!itemPanel.classList.contains('active')) {

            self.classList.add('active');
            itemPanel.classList.add('active');
            itemPanel.style.height = 'auto';
           var height = itemPanel.clientHeight + 'px';

            itemPanel.style.height = '0px';

            setTimeout(function () {
              itemPanel.style.height = height;
            }, 0);
                  setTimeout(function() {
                      itemPanel.style.height = 'auto';
          },300);

          } else {
   
        var height = itemPanel.clientHeight + 'px';

             itemPanel.style.height = height;
             setTimeout(function () {
              itemPanel.style.height = '0px';
            }, 0);
           

            itemPanel.addEventListener('transitionend', function () {
              itemPanel.classList.remove('active');
              self.classList.remove('active');
            }, {
              once: true
            });

          }

        });
      });
    }

    var filter_titles = container.querySelectorAll('.category-filters-section-title');
    if(filter_titles.length) {
      filter_titles.forEach(function(item,index) {



        var self = item;
        var parentArea = self.closest('.category-filters-area-section');
        var filtersBlock = parentArea.querySelector('.category-filters-area-list');

        if (filtersBlock.classList.contains('active')) {
          filtersBlock.style.height = 'auto';
          var height = filtersBlock.clientHeight + 'px';
          filtersBlock.style.height = height;
          setTimeout(function() {
                      filtersBlock.style.height = 'auto';
          },300);

        } else {
           filtersBlock.style.height = height;
           setTimeout(function() {
          filtersBlock.style.height = '0px';
           },300);
        }


        item.addEventListener('click', function(e) {
          e.preventDefault();

          var self = this;
          var parentArea = self.closest('.category-filters-area-section');
          var filtersBlock = parentArea.querySelector('.category-filters-area-list');
          
          if (!filtersBlock.classList.contains('active')) {

            self.classList.add('active');
            filtersBlock.classList.add('active');
            filtersBlock.style.height = 'auto';

            var height = filtersBlock.clientHeight + 'px';

            filtersBlock.style.height = '0px';

            setTimeout(function () {
              filtersBlock.style.height = height;
            }, 0);
             setTimeout(function() {
                      filtersBlock.style.height = 'auto';
          },300);

          } else {

              var height = filtersBlock.clientHeight + 'px';
             filtersBlock.style.height = height;
               setTimeout(function () {
              filtersBlock.style.height = '0px';
            }, 0);
            
            self.classList.remove('active');
            filtersBlock.classList.remove('active');

          }
        });
      });
    }

    var show_more_options = container.querySelectorAll('.show_more_options');
    if(show_more_options.length) {

      container.querySelectorAll('.advanced-filters').forEach(function(filter,index) {
        var children_length = filter.querySelectorAll('li').length;
        if(children_length > 5) {

          var heigth_limit = 0;
          for(var i=0; i < filter.querySelectorAll('li').length; i++) {
            var item = filter.querySelectorAll('li')[i];
            heigth_limit = heigth_limit + item.offsetHeight;
            if(i == 4) {
              break;
            }
          }

          var show_more_option = filter.nextElementSibling;
          if(show_more_option) {
            filter.setAttribute('data-heigth_limit', heigth_limit);
            filter.style.maxHeight = heigth_limit+'px';
            show_more_option.classList.add('has-overflow');
          }
        }
      });

      show_more_options.forEach(function (btn,index) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();

          var filters_list = this.previousElementSibling;
          var heigth_limit = filters_list.getAttribute('data-heigth_limit');
          var default_text = this.getAttribute('data-default-text');

          if(this.classList.contains("openedFilter")) {    
            filters_list.style.maxHeight  = heigth_limit+'px';
            this.classList.remove('openedFilter');
            this.innerHTML = default_text;
          } else {

            var filterBlockLength = 0;
            for(var i=0; i < filters_list.querySelectorAll('li').length; i++) {
              var item = filters_list.querySelectorAll('li')[i];
              filterBlockLength = filterBlockLength + item.offsetHeight;
            }
            filters_list.style.maxHeight = filterBlockLength+'px';
            this.classList.add('openedFilter');
            this.innerHTML = theme.strings.show_less;

          }
        });
      });
    };


    var pagination_mode = container.getAttribute('data-pagination_mode');
    if(pagination_mode != 'standart') {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: pagination_mode,
        offset: 500
      });
    }

    var open_sidebar_btn  = container.querySelector('.open_mobile_sidebar');
    var close_sidebar_btn = container.querySelector('.close-collection-sidebar');
    var sidebarEl = container.querySelector('.collection-sidebar');
    var sortDrawerEl = container.querySelector('.sort-drawer');

    function closeSortDrawer() {
      if (sortDrawerEl) {
        sortDrawerEl.classList.remove('show');
      }
    }

    function closeFilterSidebar() {
      if (sidebarEl) {
        sidebarEl.classList.remove('show');
      }
    }

    function clearDrawerOverlay() {
      var filterOpen = sidebarEl && sidebarEl.classList.contains('show');
      var sortOpen = sortDrawerEl && sortDrawerEl.classList.contains('show');
      if (!filterOpen && !sortOpen) {
        document.querySelector('body').classList.remove('show_overlay');
      }
    }

    function applyFilterForm(formEl) {
      if (!formEl) return;
      var formData = new FormData(formEl);
      var searchParams = new URLSearchParams();

      // Drop empty values — blank price params (filter.v.price.gte=) make Shopify return 0 products
      formData.forEach(function(value, key) {
        if (value === null || value === undefined) return;
        if (String(value).trim() === '') return;
        searchParams.append(key, value);
      });

      var query = searchParams.toString();
      window.location.href = query
        ? window.location.pathname + '?' + query
        : window.location.pathname;
    }

    if(open_sidebar_btn) {
      open_sidebar_btn.addEventListener('click', function(e) {
        e.preventDefault();
        if(sidebarEl) {
          closeSortDrawer();
          sidebarEl.classList.add('show');
          document.querySelector('body').classList.add('show_overlay');
        }
      });
    }
    if(close_sidebar_btn) {
      close_sidebar_btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeFilterSidebar();
        clearDrawerOverlay();
      });
    }

    var activeFiltersWrap = sidebarEl && sidebarEl.querySelector('.drawer__active-filters');
    var activeFiltersList = sidebarEl && sidebarEl.querySelector('.drawer__active-filters-list');
    var filterBadgeCloseSvg = activeFiltersList && activeFiltersList.querySelector('.filter-badge .icon')
      ? activeFiltersList.querySelector('.filter-badge .icon').outerHTML
      : '<svg class="icon icon--close" viewBox="0 0 14 14" aria-hidden="true"><path d="M14 1.4L12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4 12.6 14 14 12.6 8.4 7z" fill="currentColor"/></svg>';

    function syncActiveFilterBadges() {
      if (!sidebarEl || !activeFiltersWrap || !activeFiltersList) return;

      var filterForm = sidebarEl.querySelector('.filter-form');
      activeFiltersList.querySelectorAll('.filter-badge:not([data-tag-filter])').forEach(function(badge) {
        badge.remove();
      });

      if (filterForm) {
        var clearAllLabel = (theme.strings && theme.strings.clear_all) || 'Clear all';

        filterForm.querySelectorAll('.advanced-filter [type="checkbox"]:checked').forEach(function(input) {
          var label = input.getAttribute('data-filter-label') || input.value;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'filter-badge';
          btn.setAttribute('data-param-name', input.name);
          btn.setAttribute('data-value', input.value);
          btn.setAttribute('aria-label', clearAllLabel + ': ' + label);
          btn.innerHTML = '<span></span>' + filterBadgeCloseSvg;
          btn.querySelector('span').textContent = label;
          activeFiltersList.appendChild(btn);
        });

        var priceSection = filterForm.querySelector('[data-price-filter-section]');
        var priceInputs = filterForm.querySelectorAll('.filter-group-display__price-range-input');
        var hasPrice = false;
        var priceLabelParts = [];
        priceInputs.forEach(function(input) {
          if (input.value) {
            hasPrice = true;
            priceLabelParts.push(input.value);
          }
        });
        if (hasPrice) {
          var fieldLabel = (priceSection && priceSection.getAttribute('data-filter-label')) || 'Price';
          var priceBtn = document.createElement('button');
          priceBtn.type = 'button';
          priceBtn.className = 'filter-badge filter-badge--price';
          priceBtn.setAttribute('data-price-filter', '');
          priceBtn.setAttribute('aria-label', clearAllLabel + ': ' + fieldLabel);
          priceBtn.innerHTML = '<span></span>' + filterBadgeCloseSvg;
          priceBtn.querySelector('span').textContent = fieldLabel + ': ' + priceLabelParts.join(' – ');
          activeFiltersList.appendChild(priceBtn);
        }
      }

      if (activeFiltersList.children.length) {
        activeFiltersWrap.removeAttribute('hidden');
      } else {
        activeFiltersWrap.setAttribute('hidden', '');
      }
    }

    if (activeFiltersList) {
      activeFiltersList.addEventListener('click', function(e) {
        var badge = e.target.closest('.filter-badge');
        if (!badge || !sidebarEl) return;

        if (badge.hasAttribute('data-tag-filter')) {
          var tagLink = badge.querySelector('a');
          if (tagLink && e.target !== tagLink && !tagLink.contains(e.target)) {
            e.preventDefault();
            tagLink.click();
          }
          return;
        }

        var filterForm = sidebarEl.querySelector('.filter-form');
        if (!filterForm) return;

        if (badge.hasAttribute('data-price-filter')) {
          filterForm.querySelectorAll('.filter-group-display__price-range-input').forEach(function(input) {
            input.value = '';
          });
          var rangeSliders = filterForm.querySelectorAll('.price_range');
          if (rangeSliders[0]) rangeSliders[0].value = rangeSliders[0].min;
          if (rangeSliders[1]) rangeSliders[1].value = rangeSliders[1].max;
          syncActiveFilterBadges();
          return;
        }

        var paramName = badge.getAttribute('data-param-name');
        var value = badge.getAttribute('data-value');
        var escapeAttr = window.CSS && CSS.escape
          ? CSS.escape
          : function(str) { return String(str).replace(/"/g, '\\"'); };
        var input = filterForm.querySelector('.advanced-filter [type="checkbox"][name="' + escapeAttr(paramName) + '"][value="' + escapeAttr(value) + '"]');
        if (input) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          syncActiveFilterBadges();
        }
      });
    }

    var sidebarSubmit = container.querySelector('.collection-sidebar__submit');
    if(sidebarSubmit) {
      sidebarSubmit.addEventListener('click', function(e) {
        e.preventDefault();
        var filterForm = sidebarEl && sidebarEl.querySelector('.filter-form');
        if (filterForm) {
          applyFilterForm(filterForm);
          return;
        }
        closeFilterSidebar();
        clearDrawerOverlay();
      });
    }

    var open_sort_btn  = container.querySelector('.open_sort_drawer');
    var close_sort_btn = container.querySelector('.close-sort-drawer');
    var sortDrawerSubmit = container.querySelector('.sort-drawer__submit');
    var sortDrawerRadios = container.querySelectorAll('.sort-drawer__radio');

    if(open_sort_btn) {
      open_sort_btn.addEventListener('click', function(e) {
        e.preventDefault();
        if(sortDrawerEl) {
          closeFilterSidebar();
          sortDrawerEl.classList.add('show');
          document.querySelector('body').classList.add('show_overlay');
        }
      });
    }
    if(close_sort_btn) {
      close_sort_btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeSortDrawer();
        clearDrawerOverlay();
      });
    }
    if(sortDrawerSubmit) {
      sortDrawerSubmit.addEventListener('click', function(e) {
        e.preventDefault();
        var checkedRadio = container.querySelector('.sort-drawer__radio:checked');
        if(checkedRadio && this.sortSelect) {
          this.sortSelect.value = checkedRadio.value;
          this.sortSelect.dispatchEvent(new Event('change'));
          return;
        }
        closeSortDrawer();
        clearDrawerOverlay();
      }.bind(this));
    }
    if(sortDrawerRadios.length) {
      sortDrawerRadios.forEach(function(radio) {
        radio.addEventListener('keydown', function(e) {
          if(e.key === 'Enter' && sortDrawerSubmit) {
            e.preventDefault();
            sortDrawerSubmit.click();
          }
        });
      });
    }

    // Close filter/sort drawers when clicking the overlay / outside the sheet
    document.addEventListener('click', function(e) {
      var el = e.target;
      var filterOpen = sidebarEl && sidebarEl.classList.contains('show');
      var sortOpen = sortDrawerEl && sortDrawerEl.classList.contains('show');

      if (!filterOpen && !sortOpen) return;
      if (el.closest('.open_mobile_sidebar') || el.closest('.open_sort_drawer')) return;

      if (filterOpen && !el.closest('.collection-sidebar')) {
        closeFilterSidebar();
      }
      if (sortOpen && !el.closest('.sort-drawer')) {
        closeSortDrawer();
      }
      clearDrawerOverlay();
    });


    container.querySelectorAll('.advanced-filter [type="checkbox"]').forEach(function(input) {
      input.addEventListener('change', function() {
        var parent = this.closest('.advanced-filter');
        if (parent) parent.classList.toggle('active-filter', this.checked);
        syncActiveFilterBadges();
      });
    });

    if (sidebarEl) {
      sidebarEl.querySelectorAll('.filter-group-display__price-range-input').forEach(function(input) {
        input.addEventListener('change', syncActiveFilterBadges);
      });
    }

    var check_filter_value_btns = container.querySelectorAll('.advanced-filter a');
    if(check_filter_value_btns.length) {
      check_filter_value_btns.forEach(function (item,index) {
        item.addEventListener('click',function (e) {
          e.preventDefault();
          var parentFilterNode = this.closest('.advanced-filter');
          var filterInput = parentFilterNode.querySelector('[type="checkbox"]');
          var FitersFormEl = item.closest('form');

          // Form-based filters: toggle only — Apply submits. Keeps the sheet open for multi-select.
          if (FitersFormEl && filterInput) {
            if (filterInput.disabled) return;
            filterInput.checked = !filterInput.checked;
            filterInput.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }

          if (filterInput) {
            filterInput.checked = !filterInput.checked;
          }

          if(FitersFormEl) {
            applyFilterForm(FitersFormEl);
          } else {
            var href = this.getAttribute('href');
            var search_url_size = window.location.search.length;
            if(search_url_size) {
              window.location.href = href + window.location.search;
            } else {
              window.location.href = href ;
            }
          }


        });
      });
    }


    // Price range: sync slider → text inputs only. Apply button navigates so the sheet stays open.
    var price_range_inputs =  container.querySelectorAll('.price_range'); 
    if(price_range_inputs.length) {
      document.addEventListener('change', function(e){
        var el = e.target;

        if(el.classList.contains('price_range')) {
          var FitersFormEl = el.closest('form');
          if(FitersFormEl) {

            var prices_arr = [];
            var price_range_inputs = FitersFormEl.querySelectorAll('.filter-group-display__price-range-input');
            var price_range_container = el.closest('.price_range_container');
            if(price_range_container) {
              price_range_container.querySelectorAll('.price_range').forEach(function(item,index) {
                var input_val = item.value * 1;
                prices_arr.push(input_val);
              });
              if(price_range_inputs.length) {
                var min = Math.min.apply(null, prices_arr),
                    max = Math.max.apply(null, prices_arr);
                price_range_inputs[0].value = min;
                price_range_inputs[1].value = max;
                price_range_inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
                price_range_inputs[1].dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }	

        }
      });
    }

    var active_titles_arr =  container.querySelectorAll('.category-filters-section-title.active');

      if(active_titles_arr.length) { 
        if(window.innerWidth < 750) {
          active_titles_arr.forEach(function (title,index) {
            // Keep groups with applied filters open
            var section = title.closest('.category-filters-area-section');
            if (section && section.classList.contains('has-active-filters')) return;
            title.dispatchEvent(new Event('click', { bubbles: true }));
          });
        }
      }
    
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {

      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChange);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChange);
      }

      this.mql.removeListener(this.initBreakpoints);



    }
  });

  return Collection;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();
  sections.register('collection-template', theme.Collection);
});